import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import firebase from 'firebase';
import * as firebaseui from 'firebaseui';
import { FirebaseUIModule } from 'firebaseui-angular';
import { NgxMaskModule } from 'ngx-mask';
import { PlanEffects, planReducer } from 'plan-subscription-store';
import { AppShellModule, HeaderModule, UserPlanModule } from 'psc-ng-common';
import { environment } from 'src/environments/environment';
import { SubscriptionEffects, subscriptionReducer } from 'subscription-store';

import { AppBaseComponent } from './app-base.component';
import { metaReducers } from './meta-reducer';

registerLocaleData(localePt);

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


const firebaseUiAuthConfig: firebaseui.auth.Config = {
  signInFlow: 'popup',
  signInOptions: [
    {
      requireDisplayName: true,

      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
    },
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    {
      scopes: ['public_profile', 'email'],
      customParameters: {
        auth_type: 'reauthenticate',
      },
      provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    },
  ],
  tosUrl: '<your-tos-link>',
  privacyPolicyUrl: '<your-privacyPolicyUrl-link>',
  credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
};

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AppBaseComponent],
  imports: [
    BrowserModule,
    HeaderModule,
    BrowserAnimationsModule,
    AppShellModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireMessagingModule,
    AngularFireStorageModule,
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    StoreModule.forRoot({}, { metaReducers }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([]),
    NgxMaskModule.forRoot(),

    FirebaseUIModule.forRoot(firebaseUiAuthConfig),
    StoreModule.forFeature(
      subscriptionReducer.SubscriptionFeatureKey,
      subscriptionReducer.subscriptionReducer
    ),
    EffectsModule.forFeature([SubscriptionEffects]),
    StoreModule.forFeature(planReducer.PlanFeatureKey, planReducer.planReducer),
    EffectsModule.forFeature([PlanEffects]),
    MatDialogModule,
    UserPlanModule,
  ],
  exports: [
    BrowserModule,
    HeaderModule,
    BrowserAnimationsModule,
    AppShellModule,
    AngularFireModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    StoreModule,
    StoreDevtoolsModule,
    EffectsModule,
    NgxMaskModule,
    AppBaseComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'R$ ' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
})
export class AppConfigModule {}
